import Vue from 'vue';
import VueCookies from 'vue-cookies';
import VueExcelXlsx from 'vue-excel-xlsx';
import VueSanitize from 'vue-sanitize';
import VueSession from 'vue-session';
import App from './App.vue';
import { i18n, vuetify } from './plugins/vuetify';
import router from './router';
import store from './store';

Vue.use(VueSanitize, {
    allowedTags: [
        'address',
        'article',
        'aside',
        'footer',
        'header',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'hgroup',
        'main',
        'nav',
        'section',
        'blockquote',
        'dd',
        'div',
        'dl',
        'dt',
        'figcaption',
        'figure',
        'hr',
        'img',
        'li',
        'main',
        'ol',
        'p',
        'pre',
        'ul',
        'a',
        'abbr',
        'b',
        'bdi',
        'bdo',
        'br',
        'cite',
        'code',
        'data',
        'dfn',
        'em',
        'i',
        'kbd',
        'mark',
        'q',
        'rb',
        'rp',
        'rt',
        'rtc',
        'ruby',
        's',
        'samp',
        'small',
        'span',
        'strong',
        'sub',
        'sup',
        'time',
        'u',
        'var',
        'wbr',
        'caption',
        'col',
        'colgroup',
        'table',
        'tbody',
        'td',
        'tfoot',
        'th',
        'thead',
        'tr',
        'style'
    ],
    disallowedTagsMode: 'discard',
    allowedAttributes: {
        '*': ['style'],
        a: ['style', 'href', 'name', 'target'],
        // We don't currently allow img itself by default, but this
        // would make sense if we did. You could add srcset here,
        // and if you do the URL is checked for safety
        img: ['style', 'src', 'alt']
    },
    // Lots of these won't come up by default because we don't allow them
    selfClosing: ['img', 'br', 'hr', 'area', 'base', 'basefont', 'input', 'link', 'meta'],
    // URL schemes we permit
    allowedSchemes: ['http', 'https', 'ftp', 'data', 'mailto', 'tel'],
    allowedSchemesByTag: {},
    allowedSchemesAppliedToAttributes: ['href', 'src', 'cite'],
    allowProtocolRelative: true,
    enforceHtmlBoundary: false
});

Vue.use(VueExcelXlsx);

Vue.use(VueCookies);

Vue.use(VueSession, { persist: false });

if (process.env.NODE_ENV === 'development' && process.env.VUE_APP_DATA_SOURCE === 'mock' && process.env.VUE_APP_API_URL === '') {
    require('./server').makeServer();
}

Vue.config.productionTip = false;
new Vue({
    router,
    store,
    vuetify,
    i18n,
    render: h => h(App)
}).$mount('#app');
